import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Skeleton } from 'antd'
import { withRouter } from 'react-router-dom'
import { apiPOSTReq, getPreSignedS3Url } from '../../Utils/api'
import environment from '../../environment'
import { ErrorAlert } from './Alert'
import { Flex, FlexColumn, LightContainer } from './Container'
import { LabeledInput } from './Input'
import { addressObjectToMultiLineStr, addressObjectToStr, getBPAccountsWithAccess, getDateInLocalTZ, renderBankIcon, toCurrency, countryCodeToNameMap } from '../../Utils/util'
import { Tag, Text } from './Text'
import PDFDocument from './PDFDocument'
import HiddenInfo from './HiddenInfo'
import { Table } from 'antd'
import ExchangeRate from '../Banking/Reusable/ExchangeRate'

import ChevronDown from "../../Images/chevron-down.svg"
import ChevronUp from "../../Images/chevron-up.png"
import { Button, TextButton } from './Button'
import { withTheme } from 'styled-components'
import { LoadingOutlined } from '@ant-design/icons'

class ApprovalDetail extends Component {

    state = {
        loading: true,
        coaPagination: {
            current: 1,
            pageSize: 200
        },
        disabled: true,
    }

    componentDidMount() {
        this.getObjectDetail()
    }

    getObjectDetail = () => {
        var { selectedApproval } = this.props
        console.log("ApprovalDetail getObjectDetail selectedApproval", selectedApproval)
        var viewBy = selectedApproval.objectType || ""
        if (viewBy === "Counterparty") viewBy = "COUNTERPARTIES"
        if (viewBy === "Wire") viewBy = "WIRE_TFER"
        if (viewBy === "BillPay") viewBy = "BILL_PAY"
        if (viewBy === "Instant" || viewBy === "InstantXfer") viewBy = "INSTANT_TFER"
        if (viewBy === "International") viewBy = "INTERNATIONAL_TFER"

        var body = { viewBy: viewBy, "objectId": selectedApproval.objectId, "fetchByPrimaryKey": true }
        console.log("ApprovalDetail getObjectDetail body", body)
        console.log("ApprovalDetail getObjectDetail selectedApproval", selectedApproval)
        this.setState({ loading: true })
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getObjectDetail`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                var data = resp || {}
                if (err) throw Error(err)
                if (!resp.result) throw Error(resp.responseMessage || resp.error)

                console.log("ApprovalDetail getObjectDetail", data)

                var approvalType = (selectedApproval || {}).objectType
                if (approvalType === 'Counterparty') {
                    this.getPaymentMethods(data, selectedApproval, data.counterpartiesObj)
                } else if (approvalType === 'ACH') {
                    if (data?.achTransferObj?.billId) {
                        this.getBill(data?.achTransferObj?.billId, data, selectedApproval)
                    } else {
                        var body = { viewBy: "COUNTERPARTIES", objectId: data?.achTransferObj?.counterpartyId, "fetchByPrimaryKey": false }
                        this.getCounterpartyDetail(body, selectedApproval, data)
                    }
                    this.setState({ achTransferObj: data?.achTransferObj })
                } else if (approvalType === "InstantXfer" || approvalType === "Instant") {
                    if (data?.instantTransferObj?.billId) {
                        this.getBill(data?.instantTransferObj?.billId, data, selectedApproval)
                    } else {
                        var body = { viewBy: "COUNTERPARTIES", objectId: data?.instantTransferObj?.counterpartyId, "fetchByPrimaryKey": false }
                        this.getCounterpartyDetail(body, selectedApproval, data)
                    }
                    this.setState({ instantTransferObj: data?.instantTransferObj })
                } else if (approvalType === 'Wire') {
                    if (data?.wireTransferObj?.billId) {
                        this.getBill(data?.wireTransferObj?.billId, data, selectedApproval)
                    } else {
                        var body = { viewBy: "COUNTERPARTIES", objectId: data?.wireTransferObj?.counterpartyId, "fetchByPrimaryKey": false }
                        this.getCounterpartyDetail(body, selectedApproval, data)
                    }
                    this.setState({ wireTransferObj: data?.wireTransferObj })
                } else if (approvalType === 'International') {
                    var body = { viewBy: "COUNTERPARTIES", objectId: data?.internationalTransferObj?.counterpartyId, "fetchByPrimaryKey": false }
                    this.getCounterpartyDetail(body, selectedApproval, data)
                    this.setState({ internationalTransferObj: data?.internationalTransferObj })
                } else {
                    this.setState({ showApprovalModal: true, objectDetail: data, selectedApproval, loading: false })
                }
            } catch (error) {
                ErrorAlert({ description: error.message || "Sorry, we had trouble processing your request. Please try again." })
            }
        })
    }

    handleReject = (selectedApproval) => {
        const { UserInfo } = this.props.store
        var username = UserInfo.Email
        var request = {
            "approverUserId": username,
            "InstanceId": selectedApproval.ruleInstanceId,
            "objectId": selectedApproval.objectId,
            "objectType": selectedApproval.objectType,
            "UserAction": "Rejected",
            "reason": this.state.reason,
        }
        var rejectUrl = `${environment.bbBaseUrl}/bb/approvals/reject`
        if (selectedApproval.sourceApplication == "Payables") {
            rejectUrl = `${environment.payBaseUrl}/payables/approvals/reject`
        }
        apiPOSTReq(rejectUrl, { "BankProvider": environment.bankProvider.crb }, request, (err, resp) => {
            this.setState({ loadingReject: false })
            try {
                const data = resp
                console.log("Approvals /approvals/reject", data, rejectUrl, request)
                if (data.result) {
                    this.props.onApprovalAction()

                    this.setState({ todoApprovals: [], todoPayApprovals: [], showApprovalModal: false, reason: null }, () => this.props.onSubmit())
                    if (err) throw new Error(err)
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
                ErrorAlert({ description: error.message })
            }
        })
        // }
    }

    handleApprove = (selectedApproval) => {
        const { reason, internationalQuoteInfo } = this.state
        this.setState({ reasonError: false, loadingApprove: true })
        const { UserInfo } = this.props.store
        var username = UserInfo.Email
        var request = {
            approverUserId: username,
            InstanceId: selectedApproval.ruleInstanceId,
            objectId: selectedApproval.objectId,
            objectType: selectedApproval.objectType,
            UserAction: "Approved",
            reason: reason,
            quoteId: internationalQuoteInfo?.id,
        }
        var approveUrl = `${environment.bbBaseUrl}/bb/approvals/approve`
        if (selectedApproval.sourceApplication == "Payables") {
            approveUrl = `${environment.payBaseUrl}/payables/approvals/approve`
        }

        console.log('approvals/approve body: ', request)

        apiPOSTReq(approveUrl, { "BankProvider": environment.bankProvider.crb }, request, (err, resp) => {
            this.setState({ loadingApprove: false })
            try {
                if (err) throw new Error(err)
                const data = resp || {}
                if (data.result) {
                    this.props.onApprovalAction()
                    this.setState({ todoApprovals: [], todoPayApprovals: [], showApprovalModal: false, reason: null }, () => this.props.onSubmit())
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
                ErrorAlert({ description: error.message })
            }
        })
    }

    getBill = (id, objectDetail, selectedApproval) => {
        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/getBill`, { "BankProvider": environment.bankProvider.crb }, { billId: id }, (err, resp) => {
            try {
                const data = resp
                if (data.result && data.bill) {
                    console.log("getBill", data.bill)
                    this.setState({ bill: data.bill, showApprovalModal: true, objectDetail, selectedApproval })

                    if ((data.bill || {}).previewDocumentUrls && data.bill.previewDocumentUrls.length > 0) {
                        getPreSignedS3Url({ url: data.bill.previewDocumentUrls[0].uri }, (err, preSignedUrl) => {
                            if (!err) {
                                this.setState({ billUrl: preSignedUrl })
                            }
                        })
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ loading: false, disabled: false })
            }
        })
    }

    getCounterpartyDetail = (body, selectedApproval, objectDetail) => {
        console.log("ApprovalDetail getObjectDetail getCounterpartyDetail body", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getObjectDetail`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            console.log("ApprovalDetail getObjectDetail getCounterpartyDetail resp", resp)
            try {
                var data = resp || {}
                if (err) throw Error(err)
                if (!resp.result) throw Error(resp.responseMessage || resp.error)

                this.getPaymentMethods(objectDetail, selectedApproval, data.counterpartiesObj)
            } catch (error) {
                console.log("ERRR getObjectDetail", error, err, resp)
                this.setState({ showApprovalModal: true, objectDetail, selectedApproval, loading: false })
            }
        })
    }

    getPaymentMethods = (objectDetail, selectedApproval, counterpartiesObj) => {

        apiPOSTReq(`${environment.bbBaseUrl}/bb/getPaymentMethods`, null, { objectId: counterpartiesObj.objectId }, (err, resp) => {
            try {
                const data = resp

                if (data.result) {
                    if (err) throw new Error(err)
                    var approvalType = (selectedApproval || {}).objectType
                    console.log("Pending bb/getPaymentMethods", data.paymentMethods, approvalType)

                    if (approvalType === 'Counterparty') this.setState({ transferMethods: data.paymentMethods, recipient: counterpartiesObj, disabled: false })
                    if (approvalType === 'ACH') {
                        this.setState({ transferMethod: data.paymentMethods.find(paymentMethod => paymentMethod.id === objectDetail?.achTransferObj?.paymentMethodId), recipient: counterpartiesObj, disabled: false })
                    }
                    if (approvalType === 'Wire') {
                        this.setState({ transferMethod: data.paymentMethods.find(paymentMethod => paymentMethod.id === objectDetail?.wireTransferObj?.paymentMethodId), recipient: counterpartiesObj, disabled: false })
                    }
                    if (approvalType === 'Instant') {
                        this.setState({ transferMethod: data.paymentMethods.find(paymentMethod => paymentMethod.id === objectDetail?.instantTransferObj?.paymentMethodId), recipient: counterpartiesObj, disabled: false })
                    }
                    if (approvalType === 'International') {
                        const transferMethod = data.paymentMethods.find(paymentMethod => paymentMethod.id === objectDetail?.internationalTransferObj?.paymentMethodId)
                        this.setState({ transferMethod, recipient: counterpartiesObj, objectDetail }, () => {
                            console.log("ApprovalDetail getObjectDetail transferMethod", this.state.transferMethod)
                            this.getInternationalQuote(() => { }, objectDetail?.internationalTransferObj, transferMethod)
                        })
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            } finally {
                this.setState({ showApprovalModal: true, objectDetail, selectedApproval, loading: false })
            }
        })
    }

    getRowDetails = (record, props) => {
        var { bankDetail, recipient } = record
        bankDetail = bankDetail || {}

        console.log("ApprovalDetail getRowDetails", bankDetail)

        const { accountNumber, routingNumber, accountType, checkDeliveryType, addressOnAccount, internationalPaymentDetails } = bankDetail
        const { bicSwift, routingCodeValue1, routingCodeValue2, receiverAccountNumber, bankName, routingCodeType1, routingCodeType2, iban } = internationalPaymentDetails || {}

        return (
            <LightContainer fullWidth>
                <Flex start fullWidth wrap gap='12px'>
                    {
                        accountNumber &&
                        <LabeledInput
                            label='Account Number'
                            nomargin
                            type='read-only'
                            value={accountNumber}
                            width='160px'
                        />
                    }

                    {
                        routingNumber &&
                        <LabeledInput
                            label='Routing Number'
                            nomargin
                            type='read-only'
                            value={routingNumber}
                            width='160px'
                        />
                    }

                    {
                        accountType &&
                        <LabeledInput
                            label='Account Type'
                            nomargin
                            type='read-only'
                            value={accountType}
                            width='160px'
                        />
                    }

                    {
                        checkDeliveryType &&
                        <LabeledInput
                            label='Delivery Type'
                            nomargin
                            type='read-only'
                            value={checkDeliveryType == 'PostalMail' ? 'Postal Mail' : checkDeliveryType}
                            width='150px'
                        />
                    }

                    {
                        checkDeliveryType && addressOnAccount &&
                        <LabeledInput
                            label='Delivery Address'
                            nomargin
                            type='read-only'
                            value={addressObjectToMultiLineStr(addressOnAccount)}
                            width='150px'
                        />
                    }

                    {
                        (checkDeliveryType == 'Email') &&
                        <LabeledInput
                            label='Delivery Address'
                            nomargin
                            type='read-only'
                            value={recipient.email}
                            width='150px'
                        />
                    }

                    {
                        internationalPaymentDetails?.currency &&
                        <LabeledInput
                            label='Currency'
                            nomargin
                            type='read-only'
                            value={internationalPaymentDetails?.currency?.toUpperCase()}
                            width='160px'
                        />
                    }

                    {
                        internationalPaymentDetails?.countryCode &&
                        <LabeledInput
                            label='Country'
                            nomargin
                            type='read-only'
                            value={countryCodeToNameMap[internationalPaymentDetails?.countryCode]}
                            width='160px'
                        />
                    }

                    {
                        internationalPaymentDetails?.bankName &&
                        <LabeledInput
                            label='Bank Name'
                            nomargin
                            type='read-only'
                            value={internationalPaymentDetails?.bankName}
                            width='160px'
                        />
                    }

                    {
                        bicSwift &&
                        <LabeledInput
                            label='SWIFT Code'
                            nomargin
                            type='read-only'
                            value={bicSwift}
                            width='160px'
                        />
                    }

                    {
                        iban &&
                        <LabeledInput
                            label='IBAN'
                            nomargin
                            type='read-only'
                            value={iban}
                            width='160px'
                        />
                    }

                    {
                        routingCodeValue1 &&
                        <LabeledInput
                            label={routingCodeType1?.replace(/([a-z])([A-Z])/g, '$1 $2')}
                            nomargin
                            type='read-only'
                            value={routingCodeValue1}
                            width='160px'
                        />
                    }

                    {
                        routingCodeValue2 &&
                        <LabeledInput
                            label={routingCodeType2?.replace(/([a-z])([A-Z])/g, '$1 $2')}
                            nomargin
                            type='read-only'
                            value={routingCodeValue2}
                            width='160px'
                        />
                    }

                    {
                        internationalPaymentDetails && addressOnAccount &&
                        <LabeledInput
                            label='Recipient address'
                            nomargin
                            type='read-only'
                            value={addressObjectToMultiLineStr(addressOnAccount)}
                            width='160px'
                        />
                    }
                </Flex>
            </LightContainer>
        )
    }

    getInternationalQuote = () => {
        const { objectDetail, transferMethod } = this.state
        var { internationalTransferObj } = objectDetail || {}

        const body = {
            paymentMethodId: transferMethod?.id,
            fromAmt: internationalTransferObj?.amount,
            purpose: internationalTransferObj?.purpose,
            fromAccountNumber: internationalTransferObj?.fromAccountNumber,
        }

        this.setState({ updating: true })
        console.log("TransferToRecipient getInternationalQuote", body);
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getInternationalQuote`, { BankProvider: environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp || {};
                console.log("TransferToRecipient getInternationalQuote data", data);

                if (data?.result === true) this.setState({ internationalQuoteInfo: data?.internationalQuoteInfo })
                else throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
            } catch (error) {
                console.log("TransferToRecipient getInternationalQuote", error, err, resp);
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ nextLoading: false, submitLoading: false, updating: false, disabled: false })
            }
        })
    }

    render() {
        const { loadingReject, loadingApprove, reason, transferMethods, recipient, bill, objectDetail, reasonError, transferMethod, billUrl, 
            internationalQuoteInfo, updating, loading, disabled } = this.state
        const { theme, selectedApproval } = this.props
        var { counterpartiesObj, achTransferObj, wireTransferObj, bpPaymentObj, instantTransferObj, internationalTransferObj } = objectDetail || {}
        const { sourceApplication } = selectedApproval || {}

        var Accounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true })
        var fromAccount

        if (achTransferObj) fromAccount = Accounts.find(a => a.accountNumber === achTransferObj.accountNumber)
        if (wireTransferObj) fromAccount = Accounts.find(a => a.accountNumber === wireTransferObj.accountNumber)
        if (instantTransferObj) fromAccount = Accounts.find(a => a.accountNumber === instantTransferObj.fromAccountNumber)
        if (internationalTransferObj) fromAccount = Accounts.find(a => a.accountNumber === internationalTransferObj.fromAccountNumber)

        var approvalType = (selectedApproval || {}).objectType
        if (approvalType === 'Counterparty') approvalType = "New Recipient"
        if (approvalType === 'InstantXfer' || approvalType === "Instant") approvalType = "Instant"

        const { nameOnAccount, email, type, transferMethodACH, transferMethodWire, transferMethodCheck, nickName } = recipient || {}

        const { internationalPaymentDetails } = transferMethod?.bankDetail || {}

        // var approvalType = (selectedApproval || {}).objectType
        // if (approvalType === 'Counterparty') approvalType = "New Recipient"
        // if (approvalType === 'InstantXfer' || approvalType === "Instant") approvalType = "Instant"

        var columns = [
            {
                dataIndex: 'nickName',
                key: 'nickName',
                render: (nickName, transferMethod) => <Flex start gap='8px' centerHorizontally>
                    {renderBankIcon(transferMethod.bankDetail, '24px')}
                    <Text>{nickName}</Text>
                </Flex>
            },
            {
                dataIndex: 'type',
                key: 'type',
                align: 'right',
                render: (type, transferMethod) => <Flex end gap='8px'>
                    <Tag bordered primary>{type}</Tag>
                    <Tag>{transferMethod.bankDetail.accountNumber && transferMethod.bankDetail.accountNumber.substring(transferMethod.bankDetail.accountNumber.length - 4, transferMethod.bankDetail.accountNumber.length)}</Tag>
                    {!transferMethod.active && <Tag alert>Inactive</Tag>}
                </Flex>
            },
        ]

        return (
            <>
                <Flex between gap='24px' fullWidth>
                    {
                        (bill && billUrl) &&
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ height: "auto", border: 'none', marginBottom: 10, marginTop: 15 }}>
                                <div style={{ width: 711 }}>
                                    <PDFDocument url={billUrl} fileName={bill.invoiceNumber} download height={600} width={663} />
                                </div>
                            </div>
                        </div>
                    }

                    {
                        selectedApproval &&
                        <FlexColumn start style={{ margin: '0 10px', minHeight: 600 }} fullWidth>
                            <Skeleton loading={loading} active title={false} paragraph={{ rows: 20 }}>
                                <Text heading>{`${sourceApplication === 'Payables' ? 'Bill Payments - ' : ''}${approvalType}${['ACH', 'Wire', 'Instant'].includes(approvalType) ? ' Transfer' : ''}`} Approval</Text>

                                {
                                    (achTransferObj) &&
                                    <FlexColumn start>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{sourceApplication === 'Payables' ? 'BILL DETAILS' : 'TRANSFER DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {/* <Text>{selectedApproval.contextIdentifier}</Text> */}
                                            <LabeledInput type='read-only' key="initiatedBy" label="Created by" value={selectedApproval.initiatedBy} width='160px' />
                                            <LabeledInput type='read-only' key="amount" label="Amount" color={theme.colors.creditGreen} value={<b>{`$${toCurrency(achTransferObj.amount)}`}</b>} width='160px' />
                                            {fromAccount && <LabeledInput type='read-only' key="From" label="From Account" value={`${fromAccount.productType} • ${fromAccount.mask}`} width='160px' />}
                                            {sourceApplication !== 'Payables' && !achTransferObj.purpose && achTransferObj.description && <LabeledInput type='read-only' key="Description" label="Description" value={achTransferObj.description} width='160px' />}
                                            {/* {achTransferObj.userNote && <LabeledInput type='read-only' key="userNote" label="Note" value={achTransferObj.userNote} withdivider />} */}
                                            {!achTransferObj?.scheduledDate && (bill?.status == 'Pending Approval') && <LabeledInput type='read-only' label="Payment Date" value={"Initiated on approval"} width='160px' />}
                                            {achTransferObj?.scheduledDate && achTransferObj.createdAt && <LabeledInput type='read-only' label="Approval Submitted Date" value={getDateInLocalTZ(achTransferObj.createdAt)} width='160px' />}
                                            {achTransferObj?.scheduledDate && <LabeledInput key='scheduledDateStr' type='read-only' label="Payment Scheduled" value={getDateInLocalTZ(achTransferObj?.scheduledDate)} width='160px' />}
                                            {bill?.dueDate && <LabeledInput key="13" type='read-only' label="Due Date" value={getDateInLocalTZ(bill?.dueDate)} width='160px' />}
                                            {achTransferObj.purpose && <LabeledInput type='read-only' key="purpose" label="Purpose" value={achTransferObj.purpose} width='160px' />}
                                            {achTransferObj.remittanceInfo && <LabeledInput type='read-only' key="remittanceInfo" label="Remittance Information" value={achTransferObj.remittanceInfo} width='320px' />}
                                        </Flex>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{sourceApplication === 'Payables' ? 'VENDOR DETAILS' : 'RECIPIENT DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {achTransferObj.counterpartyName && <LabeledInput type='read-only' key="To" label="Name" value={achTransferObj.counterpartyName} width='160px' />}
                                            {recipient?.nickName && <LabeledInput type='read-only' key="To" label="Nickname" value={recipient?.nickName} width='160px' />}
                                            {achTransferObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={achTransferObj.email} width='160px' />}
                                            {transferMethod?.bankDetail?.accountType && <LabeledInput type='read-only' key="Account Type" label="Account Type" value={transferMethod?.bankDetail?.accountType} width='160px' />}
                                            {transferMethod?.bankDetail?.accountNumber && <div style={{ width: 160, margin: '15px 0' }}><HiddenInfo type='read-only-password' key="Account Number" label="Account Number" value={transferMethod?.bankDetail?.accountNumber} /></div>}
                                            {transferMethod?.bankDetail?.routingNumber && <LabeledInput type='read-only' key="Routing Number" label="Routing Number" value={transferMethod?.bankDetail?.routingNumber} width='160px' />}
                                        </Flex>
                                        <div style={{ width: '100%', height: 1, background: '#E3E6EE', margin: '4px 0' }}></div>
                                    </FlexColumn>
                                }
                                {
                                    (wireTransferObj) &&
                                    <FlexColumn start>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{sourceApplication === 'Payables' ? 'BILL DETAILS' : 'TRANSFER DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {/* <Text>{selectedApproval.contextIdentifier}</Text> */}
                                            <LabeledInput type='read-only' key="initiatedBy" label="Created by" value={selectedApproval.initiatedBy} width='160px' />
                                            <LabeledInput type='read-only' key="amount" label="Amount" color={theme.colors.creditGreen} value={<b>{`$${toCurrency(wireTransferObj.amount)}`}</b>} width='160px' />
                                            {fromAccount && <LabeledInput type='read-only' key="From" label="From Account" value={`${fromAccount.productType} • ${fromAccount.mask}`} width='160px' />}
                                            {sourceApplication !== 'Payables' && !wireTransferObj.purpose && wireTransferObj.instructions && <LabeledInput type='read-only' key="Instructions" label="Instructions" value={wireTransferObj.instructions} width='160px' />}
                                            {wireTransferObj.purpose && <LabeledInput type='read-only' key="purpose" label="Purpose" value={wireTransferObj.purpose} width='160px' />}
                                            {wireTransferObj.remittanceInfo && <LabeledInput type='read-only' key="remittanceInfo" label="Remittance Information" value={wireTransferObj.remittanceInfo} width='320px' />}
                                        </Flex>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{sourceApplication === 'Payables' ? 'VENDOR DETAILS' : 'RECIPIENT DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {wireTransferObj.counterpartyName && <LabeledInput type='read-only' key="To" label="Name" value={wireTransferObj.counterpartyName} width='160px' />}
                                            {recipient?.nickName && <LabeledInput type='read-only' key="To" label="Nickname" value={recipient?.nickName} width='160px' />}
                                            {wireTransferObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={wireTransferObj.email} width='160px' />}
                                            {transferMethod?.bankDetail?.accountType && <LabeledInput type='read-only' key="Account Type" label="Account Type" value={transferMethod?.bankDetail?.accountType} width='160px' />}
                                            {transferMethod?.bankDetail?.accountNumber && <div style={{ width: 160, margin: '15px 0' }}><HiddenInfo type='read-only-password' key="Account Number" label="Account Number" value={transferMethod?.bankDetail?.accountNumber} /></div>}
                                            {transferMethod?.bankDetail?.routingNumber && <LabeledInput type='read-only' key="Routing Number" label="Routing Number" value={transferMethod?.bankDetail?.routingNumber} width='160px' />}
                                            {transferMethod?.bankDetail?.bankName && <LabeledInput type='read-only' key="bankName" label="Bank Name" value={transferMethod?.bankDetail?.bankName} width='160px' />}
                                            {transferMethod?.bankDetail?.bankAddress && <LabeledInput type='read-only' key="bankAddress" label="Bank Address" value={addressObjectToStr(transferMethod?.bankDetail?.bankAddress)} width='160px' />}
                                            {/* {wire && <LabeledInput type='read-only-password' key="accountNumber" label="Account Number" value={wire.accountNumber} width='160px' />}
                                    {wire && <LabeledInput type='read-only' key="routingNumber" label="Routing Number" value={wire.routingNumber} width='160px' />}
                                    {wire && <LabeledInput type='read-only' key="bankName" label="Bank Name" value={wire.bankName} width='160px' />}
                                    {wire && <LabeledInput type='read-only' key="bankAddress" label="Bank Address" value={addressObjectToStr(wire.bankAddress)} width='160px' />} */}
                                        </Flex>
                                        <div style={{ width: '100%', height: 1, background: '#E3E6EE', margin: '4px 0' }}></div>
                                    </FlexColumn>
                                }
                                {
                                    bpPaymentObj &&
                                    <Flex start fullWidth wrap gap='12px'>
                                        {/* <Text>{selectedApproval.contextIdentifier}</Text> */}
                                        <LabeledInput type='read-only' key="initiatedBy" label="Created by" value={selectedApproval.initiatedBy} width='160px' />
                                        <LabeledInput type='read-only' key="amount" label="Amount" color={theme.colors.creditGreen} value={<b>{`$${toCurrency(bpPaymentObj.amount)}`}</b>} width='160px' />
                                        {bpPaymentObj.billPayCounterpartyName && <LabeledInput type='read-only' key="To" label="Payment To" value={bpPaymentObj.billPayCounterpartyName} width='160px' />}
                                        {bpPaymentObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={bpPaymentObj.email} width='160px' />}
                                        {bpPaymentObj.instructions && <LabeledInput type='read-only' key="Instructions" label="Instructions" value={bpPaymentObj.instructions} width='160px' />}
                                    </Flex>
                                }
                                {
                                    instantTransferObj &&
                                    <FlexColumn start>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{sourceApplication === 'Payables' ? 'BILL DETAILS' : 'TRANSFER DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {/* <Text>{selectedApproval.contextIdentifier}</Text> */}
                                            <LabeledInput type='read-only' key="initiatedBy" label="Created by" value={selectedApproval.initiatedBy} width='160px' />
                                            <LabeledInput type='read-only' key="amount" label="Amount" color={theme.colors.creditGreen} value={<b>{`$${toCurrency(instantTransferObj.amount)}`}</b>} width='160px' />
                                            {fromAccount && <LabeledInput type='read-only' key="From" label="From Account" value={`${fromAccount.productType} • ${fromAccount.mask}`} width='160px' />}
                                            {instantTransferObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={bpPaymentObj.email} width='160px' />}
                                            {!instantTransferObj?.scheduledDate && (bill?.status == 'Pending Approval') && <LabeledInput type='read-only' label="Payment Date" value={"Initiated on approval"} width='160px' />}
                                            {instantTransferObj?.scheduledDate && instantTransferObj.createdAt && <LabeledInput type='read-only' label="Approval Submitted Date" value={getDateInLocalTZ(instantTransferObj.createdAt)} width='160px' />}
                                            {instantTransferObj?.scheduledDate && <LabeledInput key='scheduledDateStr' type='read-only' label="Payment Scheduled" value={getDateInLocalTZ(instantTransferObj?.scheduledDate)} width='160px' />}
                                            {bill?.dueDate && <LabeledInput key="13" type='read-only' label="Due Date" value={getDateInLocalTZ(bill?.dueDate)} width='160px' />}
                                            {instantTransferObj.purpose && <LabeledInput type='read-only' key="purpose" label="Purpose" value={instantTransferObj.purpose} width='160px' />}
                                            {instantTransferObj.remittanceInfo && <LabeledInput type='read-only' key="remittanceInfo" label="Remittance Information" value={instantTransferObj.remittanceInfo} width='320px' />}
                                        </Flex>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{sourceApplication === 'Payables' ? 'VENDOR DETAILS' : 'RECIPIENT DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {instantTransferObj.receiverName && <LabeledInput type='read-only' key="To" label="Name" value={instantTransferObj.receiverName} width='160px' />}
                                            {recipient?.nickName && <LabeledInput type='read-only' key="To" label="Nickname" value={recipient?.nickName} width='160px' />}
                                            {instantTransferObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={instantTransferObj.email} width='160px' />}
                                            {transferMethod?.bankDetail?.accountType && <LabeledInput type='read-only' key="Account Type" label="Account Type" value={transferMethod?.bankDetail?.accountType} width='160px' />}
                                            {transferMethod?.bankDetail?.accountNumber && <div style={{ width: 160, margin: '15px 0' }}><HiddenInfo type='read-only-password' key="Account Number" label="Account Number" value={transferMethod?.bankDetail?.accountNumber} /></div>}
                                            {transferMethod?.bankDetail?.routingNumber && <LabeledInput type='read-only' key="Routing Number" label="Routing Number" value={transferMethod?.bankDetail?.routingNumber} width='160px' />}
                                        </Flex>
                                        <div style={{ width: '100%', height: 1, background: '#E3E6EE', margin: '4px 0' }}></div>
                                    </FlexColumn>
                                }

                                {
                                    internationalTransferObj &&
                                    <FlexColumn start>
                                        <Text caption spaced weight='500' margin='24px 0 0'>{'TRANSFER DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px' style={{ marginBottom: 12 }}>
                                            {/* <Text>{selectedApproval.contextIdentifier}</Text> */}
                                            <LabeledInput type='read-only' key="initiatedBy" label="Created by" value={selectedApproval.initiatedBy} width='160px' />
                                            {internationalTransferObj.purpose && <LabeledInput type='read-only' key="purpose" label="Purpose" value={internationalTransferObj.purpose} width='320px' />}
                                            {fromAccount && <LabeledInput type='read-only' key="From" label="From Account" value={`${fromAccount.productType} • ${fromAccount.mask}`} width='160px' />}
                                            <LabeledInput type='read-only' key="amount" label="Amount" color={theme.colors.secondary} value={<Text weight="600">${toCurrency(internationalTransferObj.amount)}</Text>} width='160px' />

                                            <LabeledInput
                                                type='read-only'
                                                label="Recipient gets"
                                                value={<Flex start fullWidth centerHorizontally>
                                                    {updating ?
                                                        <LoadingOutlined style={{ color: this.props.theme.colors.primary, marginLeft: 8 }} /> :
                                                        <Text weight="600">{toCurrency(internationalQuoteInfo?.toAmount)} {internationalQuoteInfo?.currency?.toUpperCase()}</Text>
                                                    }
                                                </Flex>}
                                                color={theme.colors.secondary}
                                                width='160px'
                                            />

                                            {internationalTransferObj.toCurrency && <LabeledInput type='read-only' key="toCurrency" label="Currency" value={internationalTransferObj.toCurrency?.toUpperCase()} width='160px' />}
                                            {transferMethod?.bankDetail?.internationalPaymentDetails?.countryCode && <LabeledInput type='read-only' label="Country" value={countryCodeToNameMap[transferMethod?.bankDetail?.internationalPaymentDetails?.countryCode?.toUpperCase()]} width='282px' />}
                                            {internationalTransferObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={internationalTransferObj.email} width='160px' />}
                                            {!internationalTransferObj?.scheduledDate && (bill?.status == 'Pending Approval') && <LabeledInput type='read-only' label="Payment Date" value={"Initiated on approval"} width='160px' />}
                                            {internationalTransferObj?.scheduledDate && internationalTransferObj.createdAt && <LabeledInput type='read-only' label="Approval Submitted Date" value={getDateInLocalTZ(internationalTransferObj.createdAt)} width='160px' />}
                                            {internationalTransferObj?.scheduledDate && <LabeledInput key='scheduledDateStr' type='read-only' label="Payment Scheduled" value={getDateInLocalTZ(internationalTransferObj?.scheduledDate)} width='160px' />}
                                            {bill?.dueDate && <LabeledInput key="13" type='read-only' label="Due Date" value={getDateInLocalTZ(bill?.dueDate)} width='160px' />}
                                            {internationalTransferObj.remittanceInfo && <LabeledInput type='read-only' key="remittanceInfo" label="Remittance Information" value={internationalTransferObj.remittanceInfo} width='320px' />}
                                        </Flex>
                                        {(internationalQuoteInfo && internationalTransferObj.toCurrency !== "usd") &&
                                            <ExchangeRate
                                                width="100%"
                                                internationalQuoteInfo={internationalQuoteInfo}
                                                updating={updating}
                                                getInternationalQuote={this.getInternationalQuote}
                                            />}
                                        <Text caption spaced weight='500' margin='24px 0 0'>{'RECIPIENT DETAILS'}</Text>
                                        <Flex start fullWidth wrap gap='12px'>
                                            {internationalTransferObj.receiverName && <LabeledInput type='read-only' key="To" label="Name" value={internationalTransferObj.receiverName} width='160px' />}
                                            {recipient?.nickName && <LabeledInput type='read-only' key="To" label="Nickname" value={recipient?.nickName} width='160px' />}
                                            {internationalTransferObj.email && <LabeledInput type='read-only' key="Email" label="Email" value={internationalTransferObj.email} width='160px' />}
                                            {transferMethod?.bankDetail?.bankName && <LabeledInput type='read-only' key="bankName" label="Bank Name" value={transferMethod?.bankDetail?.bankName} width='160px' />}
                                            {internationalPaymentDetails?.receiverAccountNumber && <div style={{ width: 160, margin: '15px 0' }}><HiddenInfo type='read-only-password' key="Account Number" label="Account Number" value={internationalPaymentDetails?.receiverAccountNumber} /></div>}
                                            {internationalPaymentDetails?.routingCodeValue1 && <LabeledInput type='read-only' key="routingCodeValue1" label={internationalPaymentDetails?.routingCodeType1?.replace(/([a-z])([A-Z])/g, '$1 $2')} value={internationalPaymentDetails?.routingCodeValue1} width='160px' />}
                                            {internationalPaymentDetails?.routingCodeValue2 && <LabeledInput type='read-only' key="routingCodeValue2" label={internationalPaymentDetails?.routingCodeType2?.replace(/([a-z])([A-Z])/g, '$1 $2')} value={internationalPaymentDetails?.routingCodeValue2} width='160px' />}
                                            {internationalPaymentDetails?.bicSwift && <LabeledInput type='read-only' key="bicSwift" label="SWIFT Code" value={internationalPaymentDetails?.bicSwift} width='160px' />}
                                            {internationalPaymentDetails?.iban && <LabeledInput type='read-only' key="iban" label="IBAN" value={internationalPaymentDetails?.iban} width='160px' />}
                                        </Flex>
                                        <div style={{ width: '100%', height: 1, background: '#E3E6EE', margin: '4px 0' }}></div>
                                    </FlexColumn>
                                }

                                {
                                    (counterpartiesObj && transferMethods && recipient) &&
                                    <>
                                        <Flex start centerHorizontally gap='8px' style={{ marginTop: 10 }}>
                                            <Text caption spaced weight='500' margin='0 0 0'>{'Recipient Details'.toUpperCase()}</Text>
                                            {/* <Tag bordered primary>{type}</Tag> */}
                                        </Flex>
                                        <Flex start fullWidth wrap gap='24px'>
                                            {type && <div><LabeledInput type='read-only' key="Type" label="Type" value={type} width='160px' /></div>}
                                            {(nameOnAccount) && <div><LabeledInput type='read-only' key="To" label="Name" value={nameOnAccount} width='160px' /></div>}
                                            {(nickName) && <div><LabeledInput type='read-only' key="To" label="Nickname" value={nickName} width='160px' /></div>}
                                            {email && <div><LabeledInput type='read-only' key="Email" label="Email" value={email} /></div>}
                                        </Flex>
                                        <Text color={'#7384AA'} size='14px' weight={400} margin='8px 0 12px'>Bank Details</Text>
                                        <Table
                                            id="transfer-methods"
                                            className='borderless-table'
                                            tableLayout='auto'
                                            columns={columns}
                                            dataSource={transferMethods.sort((a, b) => b.active - a.active)}
                                            rowKey='id'
                                            pagination={false}
                                            showHeader={false}
                                            expandable={{
                                                expandedRowRender: record => this.getRowDetails({ ...record, recipient: recipient }, this.props),
                                                expandRowByClick: false,
                                                expandIconColumnIndex: 4,
                                                expandIcon: ({ expanded, onExpand, record }) => {
                                                    if (selectedApproval.dateRow) {
                                                        return null
                                                    } else {
                                                        return !expanded ? (
                                                            <img style={{ cursor: 'pointer' }} width='24px' height='24px' src={ChevronDown} onClick={e => {
                                                                // this.getRowDetail(record)
                                                                onExpand(record, e)
                                                            }} />
                                                        ) : (
                                                            <img style={{ cursor: 'pointer' }} width='24px' height='24px' src={ChevronUp} onClick={e => onExpand(record, e)} />
                                                        )
                                                    }
                                                },
                                                defaultExpandAllRows: true,
                                            }} />
                                    </>
                                }

                                <LabeledInput
                                    label="Reason"
                                    value={reason}
                                    // placeholder='Adding a reason is optional if you are approving the item'
                                    optional
                                    onChange={(e) => this.setState({ reason: e.target.value })}
                                    error={reasonError}
                                    errorMessage="Please enter a reason for rejecting this approval" />

                                <Flex start style={{ marginTop: 24 }} centerHorizontally>
                                    <Button disabled={disabled} permtype="BusinessBanking.Payments" margin='0 24px 0 0' solid loading={loadingApprove} onClick={() => this.handleApprove(selectedApproval)} text="Approve" />
                                    <TextButton permtype="BusinessBanking.Payments" loading={loadingReject} onClick={() => this.handleReject(selectedApproval)} text="Reject" />
                                </Flex>
                            </Skeleton>
                        </FlexColumn>
                    }
                </Flex>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(ApprovalDetail)))